import React from "react";
import { Box } from "@cloudscape-design/components";
import { Bar } from "react-chartjs-2";

const CHART_HEIGHT_PX = 1200;
const MAX_CONTAINER_HEIGHT_PX = 3600;

const defaultEmptyMessage = "No score data available yet.";

const LeaderboardChart = ({ title, data = [], maxScore, emptyMessage }) => {
  const labels = data.map((entry) => entry.employee ?? entry.name ?? "Unknown");
  const values = data.map((entry) => entry.avgScore ?? entry.score ?? 0);
  const resolvedMaxScore =
    Number.isFinite(maxScore) && maxScore > 0
      ? maxScore
      : Math.max(...values, 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: title || "Average score",
        data: values,
        backgroundColor: "rgba(27, 100, 217, 0.65)",
        borderColor: "rgba(27, 100, 217, 1)",
        borderWidth: 1,
        barThickness: 20,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
        max: resolvedMaxScore || undefined,
        ticks: {
          precision: 0,
        },
      },
      y: {
        ticks: {
          autoSkip: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.x}`,
        },
      },
    },
  };

  return (
    <Box>
      {title && (
        <Box fontWeight="bold" margin={{ bottom: "xs" }}>
          {title}
        </Box>
      )}
      <Box
        padding={{ vertical: "xs" }}
        style={{
          maxHeight: `${MAX_CONTAINER_HEIGHT_PX}px`,
          overflowY: "auto",
        }}
      >
        {labels.length > 0 ? (
          <Box style={{ height: `${CHART_HEIGHT_PX}px` }}>
            <Bar
              type="bar"
              data={chartData}
              options={options}
              style={{ height: `${CHART_HEIGHT_PX}px` }}
            />
          </Box>
        ) : (
          <Box color="text-body-secondary">
            {emptyMessage || defaultEmptyMessage}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LeaderboardChart;
